﻿import axios from 'axios';
import {
    AppDiffInfoResult, AppPublishStatusInfo, DeleteSnapshotCommandModel, ExportAppJsonResult, PublishVersionCommandModel,
    PublishVersionCommandResult, RollbackCommandModel, SnapshotCommandModel
} from '../../../App/Publish/Scripts/publish-index-model';
import { SoftoolsValidationResult } from '../Results/softools-validation-result';
import { BaseRepository } from './base-repository';

export interface AppPublishStatusInfoResult {
    hasAppsEditAccess?: boolean;
    appPublishStatusInfo?: AppPublishStatusInfo
}

export namespace PublishRepository {

    /**
     * Get latest App Publish Status Info.
     */
    export async function getAppPublishStatusInfo(appIdentifier: string, includePublishedTranslatedApps = false): Promise<AppPublishStatusInfoResult> {
        const url = `/App/${appIdentifier}/Publish/StatusInfo`;
        const response = await axios.get(url, {
            params: {
                includePublishedTranslatedApps
            }
        });
        const result: AppPublishStatusInfoResult = response.data;
        return result;
    }

    export async function downloadApp<T>(appIdentifier: string, jsonBlobFileName: string): Promise<T> {
        const url = `/App/${appIdentifier}/Publish/DownloadApp/${jsonBlobFileName}`;
        const response = await axios.get(url);
        const result = response.data;
        return result;
    }

    export async function publishVersion(appIdentifier: string, data: PublishVersionCommandModel): Promise<SoftoolsValidationResult> {
        const url = `/App/${appIdentifier}/Publish/PublishVersion`;
        const result = await BaseRepository.post<SoftoolsValidationResult>(url, data);
        return result;
    }

    export async function snapshot(appIdentifier: string, data: SnapshotCommandModel): Promise<PublishVersionCommandResult> {
        const url = `/App/${appIdentifier}/Publish/Snapshot`;
        const result = await BaseRepository.post<PublishVersionCommandResult>(url, data);
        return result;
    }

    export async function deleteSnapshot(appIdentifier: string, data: DeleteSnapshotCommandModel): Promise<SoftoolsValidationResult> {
        const url = `/App/${appIdentifier}/Publish/DeleteSnapshot`;
        const result = await BaseRepository.post<SoftoolsValidationResult>(url, data);
        return result;
    }

    export async function rollback(appIdentifier: string, data: RollbackCommandModel): Promise<SoftoolsValidationResult> {
        const url = `/App/${appIdentifier}/Publish/Rollback`;
        const result = await BaseRepository.post<SoftoolsValidationResult>(url, data);
        return result;
    }

    export async function exportAppJson(appIdentifier: string): Promise<ExportAppJsonResult> {
        const url = `/App/${appIdentifier}/Publish/ExportJson`;
        const result = await BaseRepository.get<ExportAppJsonResult>(url);
        return result;
    }

    export async function getAppDiffInfo(appIdentifier: string, oldAppPublishedVersionNumber?: number, newAppPublishedVersionNumber?: number): Promise<AppDiffInfoResult> {
        let url = `/App/${appIdentifier}/Publish/AppDiffInfo`;

        if (oldAppPublishedVersionNumber
            && newAppPublishedVersionNumber
        ) {
            url += `?oldAppPublishedVersionNumber=${oldAppPublishedVersionNumber}&newAppPublishedVersionNumber=${newAppPublishedVersionNumber}`
        }

        const result = await BaseRepository.get<AppDiffInfoResult>(url);
        return result;
    }

}
